import { render, staticRenderFns } from "./CreateWhoModal.vue?vue&type=template&id=22ae4dfc&"
import script from "./CreateWhoModal.vue?vue&type=script&lang=js&"
export * from "./CreateWhoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports